module.exports = __webpack_public_path__ + "static/media/task-commercial.03df969e.svg";